import { useQuery } from "@tanstack/react-query"
import { trpcClient } from "@tokenterminal/core/utils/trpc"

/**
 * Returns any metric sources and definitions for projects.
 * @example
 * const { data } = useMetricMetadataByProjectSlug(["aave", "uniswap"])
 */

export const useMetricMetadataByProjectSlug = () => {
  return useQuery({
    queryKey: ["metric-metadata-by-project-slug"],
    queryFn: async () => {
      const result = await trpcClient.projects.getMetricsMeta.query()
      return result.data
    },
    staleTime: 1000 * 60 * 10,
  })
}
